export enum QueryKeys {
  AppSettings = 'AppSettingsQueryKey',
  Billboards = 'BillboardsQueryKey',
  SupportTickets = 'SupportTicketsQueryKey',
  Clients = 'ClientsQueryKey',
  Users = 'UsersQueryKey',
  Assets = 'AssetsQueryKey',
  AssetPlannedInstallations = 'AssetPlannedInstallationsQueryKey',
  ClientInvoices = 'ClientInvoicesQueryKey',
  ClientCampaigns = 'ClientCampaignsQueryKey',
  Metrics = 'MetricsQueryKey',
  AgencyClientsList = 'AgencyClientsListQueryKey',
  Agencies = 'AgenciesQueryKey',
  AgencyClientBillboardActivationRequests = 'AgencyClientBillboardActivationRequests',
  Reports = 'ReportsQueryKey',
  BillboardCreateRequests = 'BillboardCreateRequestsQueryKey',
  BillboardProductGroups = 'BillboardProductGroupsQueryKey',
  BackgroundDataExportJobs = "BackgroundDataExportJobsQueryKey"
}